import styled from "styled-components";
import {Button} from "../../../../basic-ui-components/button/base/button.component";

export const HeaderStandardButtonBox = styled(Button)`
  min-width: 150px;
  height: 35px;
  
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    min-width: 80px;
    height: 30px;
  }
`